import React from "react";
import { ContainerModal } from "./VideoModalStyled";
var VideoModal = function (_a) {
    var videos = _a.videos;
    return (videos.length > 0 && (React.createElement(ContainerModal, null,
        React.createElement("video", { className: "media", autoPlay: true, controls: true, controlsList: "nodownload" },
            React.createElement("source", { src: videos[0].url })))));
};
export default VideoModal;
